function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4534 0H16.5464C16.2446 0 15.9999 0.240398 15.9999 0.536963V19.463C15.9999 19.7595 16.2446 20 16.5464 20H20.4534C20.7553 20 20.9999 19.7595 20.9999 19.463V0.536963C20.9999 0.240398 20.7553 0 20.4534 0Z",
  fill: "#908CA0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.45353 10H0.546472C0.244655 10 0 10.2407 0 10.5376V19.4624C0 19.7593 0.244655 20 0.546472 20H4.45353C4.75534 20 5 19.7593 5 19.4624V10.5376C5 10.2407 4.75534 10 4.45353 10Z",
  fill: "#908CA0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.54647 5H12.4535C12.7554 5 13 5.26109 13 5.58319V19.4168C13 19.7388 12.7553 20 12.4535 20H8.54647C8.24466 20 8 19.7388 8 19.4168V5.58319C8 5.26109 8.24466 5 8.54647 5Z",
  fill: "#908CA0"
});

function SvgIconAnalyticsNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalyticsNav);
export default __webpack_public_path__ + "static/media/icon-analytics-nav.8fa9bf54.svg";
export { ForwardRef as ReactComponent };